/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_PlaceholderInputs */

const en_editor_placeholder = /** @type {(inputs: Editor_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste your JSON here...`)
};

const ko_editor_placeholder = /** @type {(inputs: Editor_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여기에 JSON을 붙여넣으세요...`)
};

const ja_editor_placeholder = /** @type {(inputs: Editor_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここにJSONを貼り付けてください...`)
};

/**
* | output |
* | --- |
* | "Paste your JSON here..." |
*
* @param {Editor_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const editor_placeholder = /** @type {((inputs?: Editor_PlaceholderInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_PlaceholderInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_editor_placeholder(inputs)
	if (locale === "ko") return ko_editor_placeholder(inputs)
	return ja_editor_placeholder(inputs)
});